import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

// let abortControllerFetchModules = null;

/**
 * Gọi Api lấy danh sách module
 */
export const fetchModules = createAsyncThunk(
  'get/modules/v3/basemodules',
  async ({ offset, limit, productType, category }, { dispatch }) => {
    try {
      // if (abortControllerFetchModules) {
      //   abortControllerFetchModules.abort();
      // }
      // abortControllerFetchModules = new AbortController();

      const res = await callApi({
        endpoint: 'modules/v3/basemodules',
        method: 'get',
        params: {
          offset,
          limit,
          product_type: productType,
          category,
          country_code: process.env.REACT_APP_COUNTRY_CODE
        },
        // signal: abortControllerFetchModules.signal,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data, total: response?.count };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/**
 * Gọi Api lấy chi tiết module theo id
 * @param {string} id Id của module
 */
export const fetchModule = createAsyncThunk(
  'get/modules/v3/basemodule/id',
  async (id, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'modules/v3/basemodule/' + id,
        method: 'get',
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error?.message ?? error?.statusText,
      };
    }
  }
);

/**
 * Gọi Api lấy bảng giá cố định
 */
export const fetchPricePermanents = createAsyncThunk(
  'get/modules/v3/price-permanents',
  async (_, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'modules/v3/price-permanents',
        method: 'get',
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/** * Gọi API loại vật liệu
 * @param {Object} values Tham số truyền vào
 * @param {string} values.group_name {countertop || backsplash}
 */
export const fetchTextureType = createAsyncThunk(
  'get/modules/v3/get_texture_type',
  async ({ groupName = 'countertop' }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'modules/v3/get_texture_type',
        method: 'get',
        params: { group_name: groupName },
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/** * Gọi API nhóm chân tủ
 * @param {Object} values Tham số truyền vào
 * @param {string} values.id product type id
 */
export const fetchLegGroup = createAsyncThunk(
  'get/modules/v3/get_list_cabinet_leg_groups/?product_type={id}',
  async ({ id }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'modules/v3/get_list_cabinet_leg_groups/',
        method: 'get',
        params: { product_type: id },
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/** * Gọi API danh sách chân tủ
 * @param {Object} values Tham số truyền vào
 * @param {string} values.id leg group id
 */
export const fetchLegs = createAsyncThunk(
  'get/modules/v3/get_list_cabinet_legs/?leg_group_id={id}',
  async ({ id }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'modules/v3/get_list_cabinet_legs/',
        method: 'get',
        params: { leg_group_id: id },
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return {
          cabinet_leg_default: data?.cabinet_leg_default,
          data: data?.list_cabinet_legs,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/** * Gọi API chia sẻ thiết kế
 * @param {Object} values Tham số truyền vào
 * @param {string} values.designId design id
 * @param {string} values.toUserEmail email người nhận
 */
export const shareDesign = createAsyncThunk(
  'post/room/v3/room/share_design/',
  async ({ designId, toUserEmail }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'rooms/v3/room/share_design/',
        method: 'post',
        data: { design_id: designId, to_user_email: toUserEmail },
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return {
          cabinet_leg_default: data?.cabinet_leg_default,
          data: data?.list_cabinet_legs,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return { error: true };
    }
  }
);
